export default __webpack_public_path__ + "static/media/404.6dd6e223.svg";